import { render } from "./DriverHelpSupport.vue?vue&type=template&id=8b7dae12"
import script from "./DriverHelpSupport.vue?vue&type=script&lang=js"
export * from "./DriverHelpSupport.vue?vue&type=script&lang=js"
script.render = render

export default script